import React, { Component } from "react";
import { Container, Row, Col, Button, Form, Spinner, Card, Modal } from "react-bootstrap";
import { FaPlus, FaTrash, FaEdit } from 'react-icons/fa';
import { connect } from 'react-redux';
import { setSESProducts } from '../../actions';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class SESProductViewModal extends Component {
  state = {
    mode: this.props.mode || 'view',
    formData: null,
    newImage: {
      image_link: '',
      alt_text: ''
    },
    editingImageIndex: null,
    saving: false,
    isNewSize: false,
    product: {
      sku_code: '',
      size: '',
      style: '',
      product_name: '',
      base_price_vnd: '',
      current_qty: 0,
      current_cell_code: '',
      properties: {
        material: '',
        color: '',
        length_mm: '',
        width_mm: '',
        height_mm: '',
        weight_g: ''
      },
      suppliers: ['RESIN_HOAI_DUC']
    },
    errors: {},
    loading: false
  };

  SUPPLIERS = [
    'RESIN_HOAI_DUC',
    'BREAKWOODEN',
    'KSC_RESIN',
    'WOOD_HIEP_HOA',
    'OTHER'
  ];

  STATUS_OPTIONS = [
    { value: 'ACTIVE', label: 'Hoạt động' },
    { value: 'DEACTIVE', label: 'Không hoạt động' },
    { value: 'RND', label: 'R&D' },
    { value: 'CANCEL', label: 'Hủy' }
  ];

  getDefaultFormData = () => ({
    sku_code: '',
    product_code: '',
    version: '',
    friendly_version: '',
    product_version: 1,
    warehouse_id: 1,
    size: '',
    style: '',
    product_name: '',
    base_price_vnd: '',
    current_qty: 0,
    current_cell_code: '',
    status: 'ACTIVE',
    properties: {
      material: '',
      color: '',
      note: '',
      length_mm: '',
      width_mm: '',
      height_mm: '',
      weight_g: ''
    },
    images: [],
    is_deleted: false,
    suppliers: ['RESIN_HOAI_DUC']
  });

  componentDidMount() {
    if (this.props.currentProduct) {
      const formData = {
        ...this.props.currentProduct,
        suppliers: this.props.currentProduct.suppliers || ['RESIN_HOAI_DUC']
      };
      this.setState({ formData });
    } else {
      // Initialize formData with default values for new product
      this.setState({ formData: this.getDefaultFormData() });
    }
  }

  componentDidUpdate(prevProps) {
    // Mode changed
    if (prevProps.mode !== this.props.mode) {
      this.setState({ mode: this.props.mode });
    }

    // Product changed
    if (prevProps.currentProduct !== this.props.currentProduct) {
      if (this.props.currentProduct) {
        const formData = {
          ...this.props.currentProduct,
          suppliers: this.props.currentProduct.suppliers || ['RESIN_HOAI_DUC']
        };
        this.setState({ formData });
      } else {
        // Initialize formData with default values for new product
        this.setState({ formData: this.getDefaultFormData() });
      }
    }
  }

  handleEdit = () => {
    const { formData } = this.state;
    this.setState({
      mode: 'edit',
      formData: { ...formData } // Make a copy to ensure we're not editing the original
    });
  };

  handleClose = () => {
    const { currentProduct } = this.props;
    if (currentProduct) {
      // Reset to original data when closing edit mode
      this.setState({
        mode: 'view',
        formData: { ...currentProduct }
      });
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { mode, currentProduct } = this.props;
    const { formData } = this.state;

    try {
      this.setState({ saving: true });

      // Đảm bảo suppliers luôn là mảng
      const dataToSave = {
        ...formData,
        suppliers: formData.suppliers || ['RESIN_HOAI_DUC']
      };

      let response;
      if (mode === 'create') {
        response = await this.props.setSESProducts([dataToSave], { create_new: true });
      } else if (mode === 'edit') {
        response = await this.props.setSESProducts([dataToSave], { generate_version: true });
      }

      // Cập nhật state với dữ liệu mới từ server
      if (response && response.data && response.data.data) {
        const updatedProduct = response.data.data[0];
        this.setState({
          formData: updatedProduct,
          mode: 'view'
        });
      }

      this.props.onClose();
    } catch (error) {
      console.error('Error saving product:', error);
      alert('Failed to save product. See console for details.');
    } finally {
      this.setState({ saving: false });
    }
  };

  generateProductCode = () => {
    const { formData } = this.state;
    if (!formData.sku_code || !formData.size) return '';
    
    const productVersion = parseInt(formData.product_version, 10);
    if (productVersion === 1) {
      return `${formData.sku_code}-${formData.size}`.toUpperCase();
    } else {
      return `${formData.sku_code}-${formData.size}-v${productVersion}`.toUpperCase();
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith('properties.')) {
      const propertyName = name.split('.')[1];
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          properties: {
            ...prevState.formData.properties,
            [propertyName]: value
          }
        }
      }), this.updateProductCode);
    } else {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          [name]: value
        }
      }), this.updateProductCode);
    }
  };

  updateProductCode = () => {
    const productCode = this.generateProductCode();
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        product_code: productCode
      }
    }));
  };

  handleNewImageChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => ({
      newImage: {
        ...prevState.newImage,
        [name]: value
      }
    }));
  };

  handleAddImage = () => {
    const { newImage } = this.state;
    if (newImage.image_link) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          images: [...(prevState.formData.images || []), { ...newImage }]
        },
        newImage: {
          image_link: '',
          alt_text: ''
        }
      }));
      toast.success(getTranslate(LANGUAGE_KEYS.TEXT_IMAGE_ADDED) || 'Image added successfully!');
    }
  };

  handleRemoveImage = (index) => {
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        images: prevState.formData.images.filter((_, i) => i !== index)
      }
    }));
    toast.success(getTranslate(LANGUAGE_KEYS.TEXT_IMAGE_REMOVED) || 'Image removed successfully!');
  };

  handleEditImage = (index) => {
    const { images } = this.state.formData;
    this.setState({
      editingImageIndex: index,
      newImage: { ...images[index] }
    });
  };

  handleUpdateImage = () => {
    const { editingImageIndex, newImage } = this.state;
    if (newImage.image_link) {
      this.setState(prevState => ({
        formData: {
          ...prevState.formData,
          images: prevState.formData.images.map((img, index) => 
            index === editingImageIndex ? { ...newImage } : img
          )
        },
        editingImageIndex: null,
        newImage: {
          image_link: '',
          alt_text: ''
        }
      }));
      toast.success(getTranslate(LANGUAGE_KEYS.TEXT_IMAGE_UPDATED) || 'Image updated successfully!');
    }
  };

  handleSizeChange = (e) => {
    const value = e.target.value;
    if (value === 'new') {
      this.setState(prevState => ({
        isNewSize: true,
        formData: {
          ...prevState.formData,
          size: ''
        }
      }));
    } else {
      this.setState(prevState => ({
        isNewSize: false,
        formData: {
          ...prevState.formData,
          size: value
        }
      }));
    }
  };

  handleSupplierChange = (e) => {
    const selectedSupplier = e.target.value;
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        suppliers: [selectedSupplier]
      }
    }));
  };

  render() {
    const { mode, formData, newImage, editingImageIndex, saving } = this.state;
    const { show, currentProduct } = this.props;
    const isEditMode = mode === 'edit';
    const isNew = !currentProduct;

    console.log('ViewModal render:', { show, currentProduct, mode, isEditMode, isNew, formData });

    if (!formData) {
      console.log('ViewModal: formData is null, returning null');
      return null;
    }

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        size="xl"
        centered
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>
              {isNew
                ? getTranslate(LANGUAGE_KEYS.TEXT_ADD_NEW_PRODUCT)
                : (mode === 'view'
                  ? getTranslate(LANGUAGE_KEYS.TEXT_VIEW) + ' ' + getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)
                  : getTranslate(LANGUAGE_KEYS.TEXT_EDIT) + ' ' + getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME))}
            </Modal.Title>
            {isNew || mode === 'edit' ? (
              <Button 
                variant="success" 
                onClick={this.handleSubmit}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    {getTranslate(LANGUAGE_KEYS.TEXT_SAVE) || 'Saving...'}
                  </>
                ) : (
                  getTranslate(LANGUAGE_KEYS.TEXT_SAVE) || 'Save'
                )}
              </Button>
            ) : (
              <Button 
                variant="primary" 
                onClick={this.handleEdit}
              >
                <FaEdit /> {getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
              </Button>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SKU_CODE)} (*)</Form.Label>
                  <Form.Control
                    type="text"
                    name="sku_code"
                    value={formData.sku_code || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Supplier</Form.Label>
                  <Form.Select
                    name="supplier"
                    value={(formData.suppliers && formData.suppliers[0]) || 'RESIN_HOAI_DUC'}
                    onChange={this.handleSupplierChange}
                    disabled={!isEditMode}
                  >
                    {this.SUPPLIERS.map(supplier => (
                      <option key={supplier} value={supplier}>{supplier}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE) || 'Product Code'}</Form.Label>
                  <Form.Control
                    type="text"
                    name="product_code"
                    value={formData.product_code || ''}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_VERSION) || 'Version'}</Form.Label>
                  <Form.Control
                    type="text"
                    name="version"
                    value={formData.version || ''}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_FRIENDLY_VERSION) || 'Friendly Version'}</Form.Label>
                  <Form.Control
                    type="text"
                    name="friendly_version"
                    value={formData.friendly_version || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_VERSION) || 'Product Version'}</Form.Label>
                  <Form.Control
                    type="number"
                    name="product_version"
                    value={formData.product_version || 1}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                    min="1"
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SIZE)} (*)</Form.Label>
                  {this.state.isNewSize ? (
                    <Form.Control
                      type="text"
                      name="size"
                      value={formData.size || ''}
                      onChange={this.handleInputChange}
                      disabled={!isEditMode}
                      placeholder="Enter custom size"
                    />
                  ) : (
                    <Form.Select
                      name="size"
                      value={formData.size || ''}
                      onChange={this.handleSizeChange}
                      disabled={!isEditMode}
                    >
                      <option value="">Select Size</option>
                      {['M', 'L', 'XL', 'XXL'].map((sizeOption) => (
                        <option key={sizeOption} value={sizeOption}>
                          {sizeOption}
                        </option>
                      ))}
                      <option value="new">+ Add Custom Size</option>
                    </Form.Select>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_STYLE)}</Form.Label>
                  <Form.Control
                    type="text"
                    name="style"
                    value={formData.style || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_NAME)} (*)</Form.Label>
                  <Form.Control
                    type="text"
                    name="product_name"
                    value={formData.product_name || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_BASE_PRICE) + ' (VND)'}</Form.Label>
                  <Form.Control
                    type="number"
                    name="base_price_vnd"
                    value={formData.base_price_vnd || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_WAREHOUSE_ID) || 'Warehouse ID'}</Form.Label>
                  <Form.Control
                    type="number"
                    name="warehouse_id"
                    value={formData.warehouse_id || 1}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_QTY) || 'Current Quantity'}</Form.Label>
                  <Form.Control
                    type="number"
                    name="current_qty"
                    value={formData.current_qty || 0}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CURRENT_CELL_CODE) || 'Current Cell Code'}</Form.Label>
                  <Form.Control
                    type="text"
                    name="current_cell_code"
                    value={formData.current_cell_code || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Trạng thái</Form.Label>
                  <Form.Select
                    name="status"
                    value={formData.status || 'ACTIVE'}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  >
                    {this.STATUS_OPTIONS.map(status => (
                      <option key={status.value} value={status.value}>{status.label}</option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_VERSION) || 'Product Version'}</Form.Label>
                  <Form.Control
                    type="number"
                    name="product_version"
                    value={formData.product_version || 1}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                    min="1"
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                {/* Empty column for layout */}
              </Col>
            </Row>

            {formData.properties && (
              <>
                <h4 className="mt-4">{getTranslate(LANGUAGE_KEYS.TEXT_PROPERTIES) || 'Properties'}</h4>
                <Row>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_MATERIAL)}</Form.Label>
                      <Form.Control
                        type="text"
                        name="properties.material"
                        value={formData.properties.material || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_COLOR)}</Form.Label>
                      <Form.Control
                        type="text"
                        name="properties.color"
                        value={formData.properties.color || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={12}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_NOTE) || 'Note'}</Form.Label>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="properties.note"
                        value={formData.properties.note || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <Row>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_LENGTH) || 'Length (mm)'}</Form.Label>
                      <Form.Control
                        type="number"
                        name="properties.length_mm"
                        value={formData.properties.length_mm || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_WIDTH) || 'Width (mm)'}</Form.Label>
                      <Form.Control
                        type="number"
                        name="properties.width_mm"
                        value={formData.properties.width_mm || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_HEIGHT) || 'Height (mm)'}</Form.Label>
                      <Form.Control
                        type="number"
                        name="properties.height_mm"
                        value={formData.properties.height_mm || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group className="mb-3">
                      <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_WEIGHT) || 'Weight (g)'}</Form.Label>
                      <Form.Control
                        type="number"
                        name="properties.weight_g"
                        value={formData.properties.weight_g || ''}
                        onChange={this.handleInputChange}
                        disabled={!isEditMode}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </>
            )}

            <h4 className="mt-4">{getTranslate(LANGUAGE_KEYS.TEXT_IMAGES) || 'Images'} (*)</h4>
            {isEditMode && (
              <Row>
                <Col md={12}>
                  <Card className="mb-3">
                    <Card.Body>
                      <Row>
                        <Col md={5}>
                          <Form.Group className="mb-3">
                            <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE_URL) || 'Image URL'}</Form.Label>
                            <Form.Control
                              type="text"
                              name="image_link"
                              value={newImage.image_link}
                              onChange={this.handleNewImageChange}
                              placeholder="Enter image URL"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={5}>
                          <Form.Group className="mb-3">
                            <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_IMAGE_DESCRIPTION) || 'Image Description'}</Form.Label>
                            <Form.Control
                              type="text"
                              name="alt_text"
                              value={newImage.alt_text}
                              onChange={this.handleNewImageChange}
                              placeholder="Enter image description"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={2} className="d-flex align-items-end">
                          {editingImageIndex !== null ? (
                            <Button
                              variant="primary"
                              onClick={this.handleUpdateImage}
                              className="w-100 mb-3"
                            >
                              {getTranslate(LANGUAGE_KEYS.TEXT_UPDATE_IMAGE) || 'Update Image'}
                            </Button>
                          ) : (
                            <Button
                              variant="success"
                              onClick={this.handleAddImage}
                              className="w-100 mb-3"
                              disabled={!newImage.image_link}
                            >
                              {getTranslate(LANGUAGE_KEYS.TEXT_ADD_IMAGE) || 'Add Image'}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            )}

            {formData.images && formData.images.length > 0 && (
              <Row className="mb-4">
                <Col md={12}>
                  <div className="d-flex flex-wrap gap-3">
                    {formData.images.map((image, index) => (
                      <Card key={index} style={{ width: '200px' }}>
                        <Card.Img
                          variant="top"
                          src={image.image_link}
                          alt={image.alt_text}
                          style={{ height: '150px', objectFit: 'cover' }}
                        />
                        <Card.Body>
                          <Card.Text className="text-truncate">
                            {image.alt_text || 'No description'}
                          </Card.Text>
                          {isEditMode && (
                            <div className="d-flex justify-content-between mt-2">
                              <Button
                                variant="primary"
                                size="sm"
                                onClick={() => this.handleEditImage(index)}
                              >
                                <FaEdit /> {getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
                              </Button>
                              <Button
                                variant="danger"
                                size="sm"
                                onClick={() => this.handleRemoveImage(index)}
                              >
                                <FaTrash /> {getTranslate(LANGUAGE_KEYS.TEXT_DELETE) || 'Remove'}
                              </Button>
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    ))}
                  </div>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            {getTranslate(LANGUAGE_KEYS.TEXT_CLOSE) || 'Close'}
          </Button>
          {isEditMode && (
            <Button variant="success" onClick={this.handleSubmit}>
              {getTranslate(LANGUAGE_KEYS.TEXT_SAVE) || 'Save'}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

export default connect(null, {
  setSESProducts
})(SESProductViewModal); 